<template>
  <v-layout row justify-center>
    <v-dialog v-model="show" fullscreen transition="dialog-bottom-transition" :overlay="overlay">
      <v-card>
        <v-toolbar :dark="dark" :color="color">
          <v-btn icon @click.native="onClose()" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn :dark="dark" :flat="flat" @click.native="onClose()">{{ textButton }}</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <slot name="content"></slot>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'vuetify-fullscreen-dialog',

  props: {
    title: {
      type: String,
      default: 'Settings'
    },
    textButton: {
      type: String,
      default: 'Close'
    },
    dialog: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: true
    },
    flat: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: 'primary'
    },
    overlay: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      show: this.dialog
    }
  },

  methods:
  {
    /**
     * Get custom parameters or use the default parameters.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onClose: function onClose () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="sass">
  html
    overflow-y: auto
</style>



// WEBPACK FOOTER //
// src/components/vuetify-fullscreen-dialog.vue